<div class="body">
  <div class="sticky">
    <app-auth-side-header></app-auth-side-header>
  </div>
  <div class="back-img">
    <div class="back-btn-container container">
      <nx-link nxStyle="block">
        <a (click)="toLeave()" class="back-btn">
          <nx-icon name="arrow-left"></nx-icon>
          {{ "CHANGE_PASSWORD.BACK" | translate }}
        </a>
      </nx-link>
      <div nxRow class="forgot-password-heading">
        <div nxCol="12" class="std-ta-center">
          <span class="module-title-font">
            {{ "RESET_PASSWORD.TITLE" | translate }}
          </span>
        </div>
        <div class="input-container user-sec-width">
          <div *ngIf="(secretQuesionDesc$ | async) == null">
            <nx-formfield [label]="'LOGIN.FORM.USER_ID' | translate">
              <input
                class="regular-font-weight"
                nxInput
                type="text"
                [(ngModel)]="searchUserId"
                (keydown.enter)="onSearch()"
              />
            </nx-formfield>

            <nx-error
              nxFormfieldError
              *ngIf="failedSearchUserId || isUserIdRequired"
            >
              <p
                class="error-title match-error-title label-16-font fw-semi-bold"
              >
                {{
                  isUserIdRequired
                    ? ("RESET_PASSWORD.USER_ID_REQUIRED" | translate)
                    : (searchUserResetPasswordErrorTitle$ | async)
                }}
              </p>
              <p
                class="match-error-text label-16-font"
                *ngIf="!isUserIdRequired"
              >
                {{ searchUserResetErrorMsg$ | async }}
              </p>
            </nx-error>

            <div class="std-pd-top-m">
              <button
                nxButton
                (click)="onSearch()"
                class="site-header__button"
                nxButton="block primary"
                [disabled]="searchUserId == ''"
              >
                {{ "COMMON.SUBMIT" | translate }}
              </button>
            </div>
          </div>

          <form
            [formGroup]="forgotPasswordForm"
            (ngSubmit)="onSubmit()"
            *ngIf="secretQuesionDesc$ | async"
          >
            <nx-formfield [label]="'LOGIN.FORM.USER_ID' | translate">
              <input
                class="regular-font-weight"
                readonly
                formControlName="userId"
                nxInput
                type="email"
              />
            </nx-formfield>

            <div>
              <span class="form-label-font">
                {{ "CHANGE_PASSWORD.FORM.SECRET_QUESTION" | translate }}
              </span>
            </div>
            <div>
              <span class="form-text-font user-sec-qeustion">
                {{
                  (secretQuestionDescp$ | async)
                    ? (secretQuestionDescp$ | async)
                    : "-"
                }}
              </span>
            </div>

            <nx-formfield
              [label]="'CHANGE_PASSWORD.FORM.SECRET_ANSWER' | translate"
            >
              <input
                formControlName="secretAnswer"
                nxInput
                #secretAnswer
                type="password"
              />
              <nx-password-toggle
                [control]="secretAnswer"
                [appPasswordTouchToggle]="showSecretAnswer"
                #showSecretAnswer
                [ariaLabel]="'LOGIN.FORM.SHOW_PASSWORD' | translate"
                nxFormfieldSuffix
              ></nx-password-toggle>
            </nx-formfield>

            <nx-formfield
              [label]="'CHANGE_PASSWORD.FORM.NEW_PASSWORD' | translate"
            >
              <input formControlName="newPassword" nxInput type="password" />
              <nx-icon
                class="ie-icon done-icon"
                *ngIf="forgotPasswordForm.controls['newPassword'].valid"
              ></nx-icon>

              <nx-message
                nxFormfieldNote
                *ngIf="forgotPasswordForm.controls['newPassword'].invalid"
                class="label-16-font fw-regular"
              >
                <div style="margin-bottom: 14px">
                  <nx-icon
                    size="s"
                    name="info-circle"
                    class="info-circle"
                  ></nx-icon>
                  <span>{{ "PASSWORD_VALIDATION.TITLE" | translate }}</span>
                </div>
                <div
                  [ngClass]="
                    forgotPasswordForm.controls['newPassword'].hasError(
                      'required'
                    ) ||
                    forgotPasswordForm.controls['newPassword'].hasError(
                      'minAndMaxNum'
                    )
                      ? 'text-required'
                      : 'text-success'
                  "
                >
                  <div class="validator-container">
                    <nx-icon size="s" name="check"></nx-icon>
                  </div>
                  <p>Contain 15-20 characters</p>
                </div>
                <div
                  [ngClass]="
                    forgotPasswordForm.controls['newPassword'].hasError(
                      'required'
                    ) ||
                    forgotPasswordForm.controls['newPassword'].hasError(
                      'hasAlphanumeric'
                    )
                      ? 'text-required'
                      : 'text-success'
                  "
                >
                  <div class="validator-container">
                    <nx-icon size="s" name="check"></nx-icon>
                  </div>
                  <p>{{ "PASSWORD_VALIDATION.ALPHANUMERIC" | translate }}</p>
                </div>
                <div
                  [ngClass]="
                    forgotPasswordForm.controls['newPassword'].hasError(
                      'required'
                    ) ||
                    forgotPasswordForm.controls['newPassword'].hasError(
                      'uppercaseAndLowercase'
                    )
                      ? 'text-required'
                      : 'text-success'
                  "
                >
                  <div class="validator-container">
                    <nx-icon size="s" name="check"></nx-icon>
                  </div>
                  <p>Have 1 UPPERCASE and 1 lowercase letter</p>
                </div>
                <div
                  [ngClass]="
                    forgotPasswordForm.controls['newPassword'].hasError(
                      'required'
                    ) ||
                    forgotPasswordForm.controls['newPassword'].hasError(
                      'hasSpecialCharacters'
                    )
                      ? 'text-required'
                      : 'text-success'
                  "
                >
                  <div class="validator-container">
                    <nx-icon size="s" name="check"></nx-icon>
                  </div>
                  <p>Have 1 special character</p>
                </div>
              </nx-message>
            </nx-formfield>

            <nx-formfield
              [label]="'CHANGE_PASSWORD.FORM.CONFIRM_NEW_PASSWORD' | translate"
            >
              <input
                formControlName="confirmNewPassword"
                nxInput
                type="password"
              />
              <nx-icon
                class="done-icon"
                *ngIf="
                  forgotPasswordForm.controls['confirmNewPassword'].valid &&
                  forgotPasswordForm.controls['confirmNewPassword'].value ===
                    forgotPasswordForm.controls['newPassword'].value
                "
              ></nx-icon>
            </nx-formfield>

            <nx-error
              nxFormfieldError
              class="reset-error-msg error-title"
              *ngIf="
                forgotPasswordForm.controls['confirmNewPassword'].valid &&
                forgotPasswordForm.controls['confirmNewPassword'].value !==
                  forgotPasswordForm.controls['newPassword'].value
              "
            >
              <p
                class="error-title match-error-title label-16-font fw-semi-bold"
              >
                {{ "CHANGE_PASSWORD.FORM.PASSWORD_MISMATCH" | translate }}
              </p>
              <p class="match-error-text label-16-font">
                {{ "CHANGE_PASSWORD.FORM.TRY_AGAIN" | translate }}
              </p>
            </nx-error>

            <nx-error
              class="reset-error-msg error-title"
              nxFormfieldError
              *ngIf="backendError"
            >
              <div *ngIf="resetPasswordErrorMsg">
                <p
                  class="error-title match-error-title label-16-font fw-semi-bold"
                >
                  {{ resetPasswordErrorTitle }}
                </p>
                <p class="match-error-text label-16-font">
                  {{ resetPasswordErrorMsg }}
                </p>
              </div>
              <p
                class="match-error-text label-16-font"
                *ngIf="!resetPasswordErrorMsg"
              >
                {{ resetPasswordErrorTitle }}
              </p>
            </nx-error>

            <div class="tou-container">
              <nx-checkbox
                class="checkbox"
                formControlName="acknowledgeChecked"
              >
              </nx-checkbox>
              <p class="tou-text label-14-font">
                {{ "RESET_PASSWORD.TOU_PREFIX" | translate }}
                <b
                  class="tou-bold fw-bold"
                  (click)="toggleTermOfUse()"
                  (keydown.enter)="toggleTermOfUse()"
                  tabindex="0"
                  role="button"
                >
                  {{ "RESET_PASSWORD.TOU_LINK_TEXT" | translate }}
                </b>
                {{ "RESET_PASSWORD.TOU_SUFFIX" | translate }}
              </p>
            </div>

            <div class="std-pd-top-3m ie-padding">
              <button
                nxButton
                type="submit"
                [disabled]="
                  !forgotPasswordForm.valid ||
                  forgotPasswordForm.get('acknowledgeChecked').value == false ||
                  forgotPasswordForm.controls['confirmNewPassword'].value !==
                    forgotPasswordForm.controls['newPassword'].value
                "
                class="site-header__button button-font std-mg-bottom-m"
                nxButton="block primary"
              >
                {{ "COMMON.SUBMIT" | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
